import React from 'react';
import classnames from 'classnames';

import {Label} from '../Label';

import * as styles from './Input.module.css';

export function Input({
  label,
  type = 'text',
  name,
  value,
  onChange,
  noPadding = false,
  errorMessage,
  ...props
}) {
  const containerClassName = classnames(styles.Container, {
    [styles.NoPadding]: noPadding,
  });

  // Generate something to tie the label's htmlFor to the input
  const id = props.id ? props.id : `${Math.random()}`.slice(2, 10);
  const inputClassName = classnames(styles.Input, {
    [styles.Error]: errorMessage != null,
  });

  return (
    <div className={containerClassName}>
      <Label htmlFor={id}>{label}</Label>
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={inputClassName}
        {...props}
      />
      <p className={styles.ErrorMessage}>{errorMessage}</p>
    </div>
  );
}
